import { useState } from 'react';

import styled from 'styled-components';

import { PAGES } from '../../constants/pages';

import { TotadminPermission } from 'data/__generated__';

import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { CreateProductArrangementPopup } from './Popups/CreateProductArrangementPopup';
import { ProductArrangementsList } from './components/ProductArrangementsList';

export const ProductArrangements = () => {
    const [isCreateProductArrangementPopupOpen, setIsCreateProductArrangementPopupOpen] = useState<boolean>(false);

    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.productArrangements} />
                </HeaderTitle>
                <TotemPrimaryButton
                    onClick={() => setIsCreateProductArrangementPopupOpen(true)}
                    requiredPermissions={[TotadminPermission.ProductArrangementsManage]}
                >
                    Créer une gamme de produit
                </TotemPrimaryButton>
            </Header>
            <Content>
                <ListContainer>
                    <ProductArrangementsList />
                </ListContainer>
            </Content>
            <CreateProductArrangementPopup
                isOpen={isCreateProductArrangementPopupOpen}
                setIsOpen={setIsCreateProductArrangementPopupOpen}
            />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;

const ListContainer = styled.div`
    flex: 1;
    overflow: hidden;
`;
